import React from 'react'

function Mouth() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <g fill="currentColor">
                <path d="M.417 8.75h19.166a.408.408 0 00.392-.283.4.4 0 00-.133-.459C17.333 6.008 14.7 5 13.333 5a3.666 3.666 0 00-2.841.975c-.234.208-.325.275-.459.275-.133 0-.225-.067-.458-.275A3.667 3.667 0 006.667 5C5.3 5 2.667 6.008.158 8.008a.4.4 0 00-.133.459.408.408 0 00.392.283zM20 10.25a.425.425 0 00-.383-.25H.417a.425.425 0 00-.384.25.425.425 0 00.075.45A15.733 15.733 0 0010 15a15.733 15.733 0 009.892-4.3.425.425 0 00.108-.45z"></path>
            </g>
        </svg>
    )
}

export default Mouth
